import React from "react";
import PageHeader from "../components/PageHeader";

/**
 * PLACEHOLDER — the route and nav entry are reserved here so that the merge UI
 * can land without touching App.js or AppLayout.jsx, which three concurrent
 * work streams all need.
 *
 * Replaced by the real cluster review once GET /api/leads/duplicates exists.
 */
export default function Duplicates() {
  return (
    <div>
      <PageHeader
        eyebrow="Data quality"
        title="Duplicates"
        description="Leads that look like the same patient enquiring more than once."
      />
      <div className="px-8 py-16 text-center" data-testid="duplicates-placeholder">
        <p className="text-sm text-muted-foreground">
          Being built. Clusters of leads sharing a phone number will appear here.
        </p>
      </div>
    </div>
  );
}
